import React from "react";

export default function GetProjectStatus({ status }) {
  if (!status) return null;

  let statusText = "";

  if (status == 1) {
    statusText = "Created";
  } else if (status == 2) {
    statusText = "Work in Progress";
  } else if (status == 3) {
    statusText = "Submitted";
  } else if (status == 4) {
    statusText = "Revision";
  } else {
    statusText = "Approved";
  }

  return (
    <span>
      Status:&nbsp;{statusText}
    </span>
  );
}
